<template>
  <div class="form__block">
    <section v-if="isPwRest" id="password_reset"
      class="form_inner password_reset">
      <form @submit.prevent="forgotPw">
        <div v-if="isSend">
          <h3>{{ $t('password_reset_succeed') }}</h3>
          <p class="reset_succeed">{{ $t('front_page.email_send') }}
          </p>
        </div>
        <div v-else class="front-form-area">
          <h3>{{ $t('front_page.forget_pw') }}</h3>
          <p class="" v-html="$t('front_page.notice.pw_reset')"></p>
          <label>
            <input type="text" v-model="resetemail"
              :placeholder="$t('accounts.primary') + $t('email')">
          </label>
          <button type="submit" name="submit"
            :class="['login-bt', { 'active': resetemail && !errorEmail }]"
            :disabled="errorEmail ? true : false">
            {{ $t('bts.submit') }}</button>
        </div>



        <ul class="pwrest">
          <li v-if="pwresetError" class="error_msg" v-html="pwresetError">
          </li>
          <li v-if="errorEmail" class="error_msg" v-html="errorEmail">
          </li>
        </ul>
      </form>
      <ul class="link_sets">
        <li class="pw_reset" @click="linkAction('new_login')">
          <span>{{ $t('front_page.member_login') }}</span>
        </li>
        <li class="pw_reset" @click="linkAction('old_login')">
          <span v-html="$t('front_page.member_old.login')"></span>
        </li>
      </ul>
    </section>
    <section v-if="isOld" class="form_inner old-login">
      <h3 v-html="$t('front_page.member_old.login')"></h3>
      <h4>数字のみのアフィリエイトIDをお持ちの方</h4>
      <form :action="`${url}/cgi-bin/stats.cgi`" method="post" name="form1"
        class="item login">
        <div class="front-form-area">
          <input type="hidden" name="lang" value="jp">
          <input type="hidden" name="owner_id" value="0">
          <label for="userid">
            <input class="form-control" type="text" name="userid" value=""
              id="userid" placeholder="アフィリエイトID"></label>
          <label for="password">
            <input class="form-control" ype="password" name="passwd" value=""
              id="password" placeholder="パスワード">
            <i :class="isVisible ? 'fa fa-eye' : 'fa fa-eye-slash'"
              @click="togglePasswordVisibility"></i>
          </label>
          <button type="submit" name="login" value="login"
            class="login-bt active">{{ $t('login.login') }}</button>
        </div>
      </form>
      <ul class="link_sets">
        <li class="pw_reset" @click="linkAction('pw_reset')">
          <span>{{ $t('front_page.forget_pw') }}</span>
        </li>
        <li class="pw_reset" @click="linkAction('new_login')">
          <span v-html="$t('front_page.member_login')"></span>
        </li>
      </ul>
    </section>
    <section v-if="isNewLogin" class="form_inner">
      <h3>{{ $t('front_page.member_login') }}</h3>
      <p v-if="loginAttempt > 4" v-html="$t('error.login_attempt')"></p>
      <form v-else @submit.prevent="logIn">
        <div class="front-form-area">
          <label for="userid">
            <input class="form-control" type="type" id="userid" v-model="userid"
              :placeholder="$t('userid')"></label>
          <label for="password">
            <input class="form-control" type="password" id="password"
              v-model="password" :placeholder="$t('password')">
            <i :class="isVisible ? 'fa fa-eye' : 'fa fa-eye-slash'"
              @click="togglePasswordVisibility"></i>
          </label>
          <button type="submit"
            :class="['login-bt', { 'active': userid && password }]"
            :disabled="userid && password ? false : true">
            {{ $t('login.login') }}</button>
        </div>
        <div class="error_msg" v-if="error">
          <span v-html="$t('login_error.' + error)"></span>
          <span v-if="errorMsg != null">{{ errorMsg }}</span>
        </div>
      </form>
      <ul class="link_sets">
        <li class="pw_reset" @click="linkAction('pw_reset')">
          <span>{{ $t('front_page.forget_pw') }}</span>
        </li>
        <li class="pw_reset" @click="linkAction('old_login')">
          <span v-html="$t('front_page.member_old.login')"></span>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { textValidation } from "@/shared"
export default {
  name: 'LoginPage',
  data() {
    return {
      url: process.env.VUE_APP_OLDURL,
      userid: null,
      password: null,
      resetemail: null,
      email: null,
      error: null,
      errorEmail: null,
      errorMsg: null,
      loginAttempt: 0,
      pwresetError: null,
      isPwRest: false,
      isNewLogin: true,
      isOld: false,
      isSend: false,
      isVisible: false
    }
  },
  mixins: [textValidation],
  computed: {
    lang() {
      return this.$store.state.locales.locale;
    }
  },
  watch: {
    "resetemail": {
      handler(e) {
        console.log(e)
        if (e === "") {
          this.errorEmail = e
        }
      }
    },
    "email": {
      handler(e) {
        this.checkError(e)
      }
    },
    userid(val) {
      this.error = null;
      this.errorMsg = null;
    },
    password(val) {
      this.error = null;
      this.errorMsg = null;
    },
  },
  methods: {
    linkAction(str) {
      switch (str) {
        case 'pw_reset':
          this.isNewLogin = this.isOld = false;
          this.isPwRest = true;
          this.isSend = false;
          break
        case 'new_login':
          this.isPwRest = this.isOld = false;
          this.isNewLogin = true;
          break
        case 'old_login':
          this.isPwRest = this.isNewLogin = false;
          this.isOld = true;
          break
      }
    },
    togglePasswordVisibility() {
      const passwordInput = document.getElementById('password');
      this.isVisible = !this.isVisible;
      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
      } else {
        passwordInput.type = 'password';
      }
    },
    logIn() {
      const loginParams = {
        userid: this.userid,
        password: this.password
      };
      this.$store.dispatch("auths/logInAction", loginParams)
        .then(login => {
          this.loginSuccessful(login);
          // return this.$store.dispatch("locales/getLocaleActions");
        })
        .then(() => {
          return this.$store.dispatch('tools/updateIsNotice', true);
        })
        .catch(error => {
          this.loginFailed(error);
        });
    },
    loginSuccessful(response) {
      let redirectPath = ''
      if (!response.access_token) {
        this.loginFailed(response)
        return
      }
      if (response.first_login) {
        redirectPath = ('/first_login')
      } else {
        redirectPath = this.$route.query.redirect || '/dashboard'
      }
      localStorage.csrf = response.access_token
      localStorage.expire = response.access_expire_at
      localStorage.refresh = response.refresh_token
      // localStorage.refresh_expire = response.refresh_expire_at
      localStorage.userid = this.userid
      localStorage.logIn = true
      this.$emit('endTime', response.refresh_expire_at)
      this.error = ''
      this.$nextTick(() => {
        this.$router.push(redirectPath);
      });
    },
    loginFailed(error) {
      let status = error.response.status || ''
      if (status === 401) {
        console.log(status)
        const message = error.response.data.message;
        if (message.includes('Locked account: true.')) {
          this.errorMsg = null;
          this.error = 'locked';
        } else if (message.includes('Inactive userid.')) {
          this.errorMsg = null;
          this.error = 'inactive';
          return
        } else {
          let error_counts = Number(message.split(':')[1]);
          this.errorMsg = isNaN(error_counts) ? null : `${this.$t('login_error.failed')} (${error_counts}/4)`;
          this.error = status;
        }
      } else {
        this.error = status;
      }
      this.deleteLocalStorage();
    },
    deleteLocalStorage() {
      console.log('Delete localStorage');
      localStorage.clear();
    },
    checkError(e) {
      this.errorEmail = this.checkEmail(e) ? this.$i18n.t('error.email_invalid') : null
    },
    forgotPw() {
      this.checkError(this.resetemail);
      if (this.errorEmail == null) {
        const params = { email: this.resetemail };
        this.$store.dispatch("auths/forgotPasswordAction", params)
          .then(response => {
            if (response.status == 200) {
              this.pwresetError = null
              this.isSend = this.$t('email_send');
            } else {
              this.isSend = null
              this.pwresetError = this.$t('pw_error.' + response.response.status);
            }

          }
          )
          .catch(error => {
            this.isSend = null
            this.pwresetError = this.$t('error.generic_error', error);
          });
      }
    }
  }
}
</script>

<style scoped>
@import '@/assets/front/form.css';

.error_msg span:last-child {
  padding-left: 1rem;
}
</style>
